import { useContext } from 'react';
import ImageLoadingContext from '../contexts/ImageLoadingContext';

const useImageLoading = () => (
  useContext(ImageLoadingContext)
);

export default useImageLoading;
